import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

export default function ProtectedRoute({ children }) {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setStatus(user ? "auth" : "unauth");
    });
    return () => unsub();
  }, []);

  if (status === "checking") {
    return (
      <div style={styles.screen}>
        <div style={styles.spinner} />
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
          @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        `}</style>
      </div>
    );
  }

  if (status === "unauth") {
    return (
      <div style={styles.screen}>
        <style>{`
          @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400&family=Cormorant+Garamond:wght@300;400&display=swap');
        `}</style>

        {/* thin gold top line */}
        <div style={styles.topLine} />

        <div style={styles.content}>
          <p style={styles.label}>Access Restricted</p>
          <p style={styles.heading}>Registered Users Only</p>
          <div style={styles.divider} />
          <p style={styles.sub}>Redirecting you to login…</p>
        </div>

        {/* thin gold bottom line */}
        <div style={styles.bottomLine} />

        <AutoRedirect />
      </div>
    );
  }

  return children;
}

function AutoRedirect() {
  const [go, setGo] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setGo(true), 2500);
    return () => clearTimeout(t);
  }, []);
  return go ? <Navigate to="/login" replace /> : null;
}

const styles = {
  screen: {
    position: "fixed",
    inset: 0,
    background: "#06120d",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Montserrat', 'Helvetica Neue', sans-serif",
  },
  spinner: {
    width: 26,
    height: 26,
    border: "1.5px solid rgba(201, 176, 122, 0.18)",
    borderTopColor: "rgba(201, 176, 122, 0.75)",
    borderRadius: "50%",
    animation: "spin 0.85s linear infinite",
  },
  topLine: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "1px",
    background:
      "linear-gradient(90deg, transparent, rgba(201,176,122,0.35), transparent)",
  },
  bottomLine: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "1px",
    background:
      "linear-gradient(90deg, transparent, rgba(201,176,122,0.35), transparent)",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "14px",
    animation: "fadeIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both",
  },
  label: {
    margin: 0,
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 300,
    fontSize: "0.6rem",
    letterSpacing: "0.45em",
    textTransform: "uppercase",
    color: "rgba(201, 176, 122, 0.5)",
  },
  heading: {
    margin: 0,
    fontFamily: "'Cormorant Garamond', Georgia, serif",
    fontWeight: 300,
    fontSize: "clamp(1.4rem, 4vw, 2rem)",
    letterSpacing: "0.18em",
    color: "rgba(201, 176, 122, 0.88)",
    textAlign: "center",
  },
  divider: {
    width: "40px",
    height: "1px",
    background: "rgba(201, 176, 122, 0.3)",
  },
  sub: {
    margin: 0,
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 300,
    fontSize: "0.58rem",
    letterSpacing: "0.3em",
    textTransform: "uppercase",
    color: "rgba(201, 176, 122, 0.35)",
  },
};
